<li class="pointer">
    <div class="pointer-inner">
        <div class="arrow"></div>
    </div>
</li>
<ng-container *ngIf="activities.length > 0 && !isLoading">
    <li *ngFor="let activity of activities; let i = index;" class="item" role="menuitems"  style="padding:5px" 
        [ngClass]="{'activity-list-item': context =='candidateCard' || context =='candidateJobMatchCard'}">
        <div *ngIf="context =='candidateCard' || context =='candidateJobMatchCard' || context === 'requisitionCard' || context == 'userCard' || context === 'employeeCard'"
            (click)="expandText($event, activity)" style="color:black">
            <div class="col-xs-12 cursor-pointer">
                <div style="-webkit-box-orient: vertical" [ngClass]="{'two-line-text-overflow-ellipsis': activity.showShortMessageFlag}">
                    <div [innerHTML]="activity.activityDisplayValue" style="display:inline"></div>
                    <ng-template #activityNotesDisplayTemplate><span [innerHtml]="activity.notesDisplay"></span></ng-template>
                    <span *ngIf="activity.notesDisplay && !activity.isDocumentEmailActivity" class="fas fa-clipboard notes-icon ml-1" [tooltip]="activityNotesDisplayTemplate" 
                        tooltip-placement="auto top-left" container="body">
                    </span>
                    <span *ngIf="activity.isDocumentEmailActivity" class="fas fa-clipboard notes-icon ml-2" tooltip="Click to View Document Details" 
                        tooltip-placement="auto top-left" container="body" (click)="goToCandidateDocuments(activity)">
                    </span>
                    <span *ngIf="activity.showNoLongerMatchResults" class="fas fa-clipboard notes-icon ml-2" tooltip="Click to Reasons for candidate mismatch" 
                        tooltip-placement="auto top-left" container="body" (click)="goToCandidateNoLongerMatchReasons(activityNoLongerMatchReasonsTemplate, activity)">
                    </span>
                    <span *ngIf="activity.showOutreachNoResponseIcon" class="fas fa-clipboard notes-icon ml-2" tooltip="Click to Job Matches" 
                        tooltip-placement="auto top-left" container="body" (click)="goToCandidateOutreachNoResponseModal(activityoutreachNoResponseTemplate, activity)">
                    </span>
                    <span *ngIf="activity.showClientReviewAuditDetails" class="fas fa-clipboard notes-icon ml-2 cursor-pointer"
                        tooltip="Click to View Client Review Details" tooltip-placement="auto top-left" container="body"
                        (click)="goToClientReviewAuditModal(activityClientReviewTemplate, activity)">
                    </span>
                </div>
            </div>
            <div class="col-xs-12 text-left" style="font-size:0.8em; padding-top:5px; padding-left: 10px;">
                <span [textContent]="activity.createdDate | fourDotFiveTimeStampFormatPipe"></span>
            </div>
            <div class="col-xs-12">
                <hr class="recent-activity-divider">
            </div>
        </div>
    </li>
</ng-container>
<li *ngIf="activities.length > 0 && !isLoading" class="item text-center cursor-pointer">
    <div (click)="showAllActivity()" class="activity-item activity-item-info">
        Show All
    </div>
</li>
<li class="item text-center cursor-pointer" *ngIf="activities.length == 0 && !isLoading">
    <div class="activity-item activity-item-info">
        No activity recorded.
    </div>
</li>
<li class="item text-center cursor-pointer" *ngIf="isLoading">
    <div class="activity-item activity-item-info">
        <span class="fa fa-spinner fa-spin"></span>
    </div>
</li>

<ng-template #activityNoLongerMatchReasonsTemplate>
    <div class="modal-header" style="padding: 15px !important; border-bottom: 1px solid #e5e5e5;">
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"
            (click)="showCandidateNoLongerMatchModal.hide()">×</button>
        <h4 class="modal-title wrap-text-in ng-binding">Reasons for Candidate Mismatch</h4>
    </div>

    <div class="modal-body">
        <div class="row">
            <div class="col-xs-12 px-4">
                <div class="clearfix">
                    <div style="max-height: 350px; overflow: auto;">
                        <div *ngIf="noLongerMatchActivityReasons.length > 0">
                            <table class="table table-bordered table-responsive">
                                <thead>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let reason of noLongerMatchActivityReasons;">
                                        <td [innerHtml]="reason" class="font-bold" style="line-height: 2; font-size: 13px;">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div *ngIf="!noLongerMatchActivityReasons.length">
                            No reasons available.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</ng-template>

<ng-template #activityoutreachNoResponseTemplate>
    <div class="modal-header" style="padding: 15px !important; border-bottom: 1px solid #e5e5e5;">
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"
            (click)="showCandidateOutreachNoResponseModal.hide()">×</button>
        <h4 class="modal-title wrap-text-in ng-binding">Job Matches</h4>
    </div>

    <div class="modal-body">
        <div class="">
            <div class="clearfix">
                <div style="max-height: 350px; overflow: auto;">
                    <div class="col-xs-12 px-0-12 outreach-job-match-table">
                        <table width="100%" class="table-bordered feedback-requisitions-table">
                            <thead>
                                <tr style="line-height: 1.5; background-color: #03a9f426;">
                                    <th>Req#</th>
                                    <th>Title</th>
                                    <th>{{isStaffingCompany ? 'Client @ Location' :
                                        'Corporate/BU @ Location'}}</th>
                                    <th>Match</th>
                                    <th>Missing/Non matched information</th>
                                    <th>Outreach Status</th>
                                    <th>Days since Outreach</th>
                                </tr>
                            </thead>
                            <tbody
                                *ngIf="outreachNoResponseJobMatches.length > 0">
                                <tr *ngFor="let jobMatch of outreachNoResponseJobMatches; let i = index"
                                    [ngClass]="{ 'disablescreen row-disabled': !jobMatch.jobMatchActive }">
                                    <td><span>{{ jobMatch.requisitionNumber }}</span></td>
                                    <td>
                                        <a class="cursor-pointer"
                                            (click)="openModal(jobMatch.jobId, jobProfileTemplate, 'jobProfile')">
                                            {{ jobMatch.title }}
                                        </a>
                                        <div class="mt-3 pl-3">
                                            <app-candidate-card-icons context="outreachNoResponse" [candidate]="jobMatch"
                                                [requisitionSponsorships]="jobMatch.missingOrNonMatchedInfo.requisitionSponsorships"
                                                [candidateAdditionalDetails]="jobMatch.missingOrNonMatchedInfo"
                                                [candidateSalaryDurationOptions]="salaryDurationOptions"
                                                [jobTypeList]="jobTypeList">
                                            </app-candidate-card-icons>
                                        </div>
                                        <div class="outreach-job-match-detail-container">
                                            <div class="outreach-job-match-detail-row">
                                                <span class="outreach-job-match-detail-heading">Preferred Job Type:</span>
                                                <span
                                                    class="outreach-job-match-detail-value">{{jobMatch.jobDetails.preferredJobType}}</span>
                                            </div>
                                            <div class="outreach-job-match-detail-row">
                                                <span class="outreach-job-match-detail-heading">Salary/Rate:</span>
                                                <span
                                                    class="outreach-job-match-detail-value">{{jobMatch.jobDetails.salary}}</span>
                                            </div>
                                            <div class="outreach-job-match-detail-row">
                                                <span class="outreach-job-match-detail-heading">Sponsorship:</span>
                                                <span
                                                    class="outreach-job-match-detail-value">{{jobMatch.jobDetails.sponsorships}}</span>
                                            </div>
                                            <div class="outreach-job-match-detail-row">
                                                <span class="outreach-job-match-detail-heading">Work Location:</span>
                                                <span
                                                    class="outreach-job-match-detail-value">{{jobMatch.jobDetails.workLocations}}</span>
                                            </div>
                                        </div>
                                    </td>
                                    <td>{{jobMatch.companyLocationLabel}}</td>
                                    <td>{{jobMatch.candidateMatch}}</td>
                                    <td class="px-2">
                                        <ul *ngIf="jobMatch.missingOrNonMatched.length > 0" class="list-unstyled">
                                            <li *ngFor="let missingInfo of jobMatch.missingOrNonMatched; let i = index">
                                                <span>{{i + 1}}. {{ missingInfo }}</span>
                                                <span class="fa fa-exclamation-circle red ml-2"
                                                    uib-tooltip="Missing Information" style="font-size: 12px;"></span>
                                            </li>
                                        </ul>
                                        <p *ngIf="!jobMatch.missingOrNonMatched || jobMatch.missingOrNonMatched.length == 0"
                                            class="d-flex justify-content-center">-</p>
                                    </td>
                                    <td>
                                        {{ jobMatch.formattedOutreachStatus }}
                                    </td>
                                    <td>{{ jobMatch.daysSinceOutreach }}</td>
                                </tr>
                            </tbody>
                            <tbody *ngIf="!outreachNoResponseJobMatches || outreachNoResponseJobMatches.length == 0">
                                <tr>
                                    <td colspan="8" class="text-center">No Job Matches Found</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #activityClientReviewTemplate>
    <div class="modal-header" style="padding: 15px !important; border-bottom: 1px solid #e5e5e5;">
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"
            (click)="showClientReviewAuditModal.hide()">×</button>
        <h4 class="modal-title wrap-text-in ng-binding">Client Review</h4>
    </div>

    <div class="modal-body">
        <div class="row">
            <div class="col-xs-12 px-4">
                <div class="clearfix">
                    <div style="max-height: 500px; overflow: auto;">
                        <div *ngIf="clientReviewAuditData">
                            <!-- Sent Information Section -->
                            <div class="mb-4">
                                <h5 class="emerald font-bold mb-3">Client Review Sent</h5>
                                <table class="table table-bordered table-striped">
                                    <tbody>
                                        <tr>
                                            <td class="font-bold" style="width: 30%;">Sent DateTime</td>
                                            <td>{{ clientReviewAuditData.sentDateTime }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-bold">Recipients</td>
                                            <td>{{ clientReviewAuditData.recipients }}</td>
                                        </tr>
                                        <tr *ngIf="currentActivity && currentActivity.fromState">
                                            <td class="font-bold">Step/State</td>
                                            <td>{{ currentActivity.fromState }}</td>
                                        </tr>
                                        <tr>
                                            <td class="font-bold">Information Sent</td>
                                            <td>
                                                <button class="btn btn-sm btn-primary" (click)="toggleClientReviewInfoModal()">
                                                    <i class="fa fa-eye mr-2"></i>View Email Details
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <!-- Response Information Section -->
                            <div class="mb-4" *ngIf="clientReviewAuditData.responseReceived">
                                <h5 class="emerald font-bold mb-3">Response Received</h5>
                                <table class="table table-bordered table-striped">
                                    <tbody>
                                        <tr>
                                            <td class="font-bold" style="width: 30%;">Response DateTime</td>
                                            <td>{{ clientReviewAuditData.responseReceivedDateTime }}</td>
                                        </tr>
                                        <tr *ngIf="clientReviewAuditData.responseNote">
                                            <td class="font-bold">Response Note</td>
                                            <td>{{ clientReviewAuditData.responseNote }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <!-- Email Details Modal Content -->
                            <div class="mt-4" *ngIf="showClientReviewInfo && clientReviewAuditData.informationSent">
                                <h5 class="emerald font-bold mb-3">Email Details</h5>
                                <div class="border p-3" style="background-color: #f5f5f5;">
                                    <div class="mb-3">
                                        <span class="font-bold">Subject:</span>
                                        <p>{{ clientReviewAuditData.informationSent.subject }}</p>
                                    </div>
                                    <hr>
                                    <div class="mb-3">
                                        <span class="font-bold">Body:</span>
                                        <div [innerHtml]="clientReviewAuditData.informationSent.body" 
                                            style="border: 1px solid #ddd; padding: 10px; background-color: white;"></div>
                                    </div>
                                    <hr>
                                    <div>
                                        <span class="font-bold">Candidate Information Sent:</span>
                                        <table class="table table-bordered table-sm mt-2">
                                            <thead>
                                                <tr style="background-color: #03a9f426;">
                                                    <th>Field</th>
                                                    <th>Value</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let field of clientReviewAuditData.informationSent.fields">
                                                    <td class="font-bold">{{ field.fieldLabel }}</td>
                                                    <td>{{ field.fieldValue }}</td>
                                                </tr>
                                                <tr *ngIf="!clientReviewAuditData.informationSent.fields || clientReviewAuditData.informationSent.fields.length === 0">
                                                    <td colspan="2" class="text-center">No fields sent</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="!clientReviewAuditData">
                            No client review audit data available.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>